import React from 'react';
import { connect } from 'react-redux';
import { SrpSaveSearchUI } from 'site-modules/shared/components/inventory/srp-save-search/srp-save-search-ui';

// we use redux here in order to avoid resolving the paths
const mapStateToProps = state => ({
  selectedFacets: state?.inventory?.searchResultsFilter,
  searchResults: state?.inventory?.searchResults,
});

export const UsurpSaveSearchDataProviderUI = props => {
  return <SrpSaveSearchUI {...props} />;
};

export const UsurpSaveSearchDataProvider = connect(mapStateToProps)(UsurpSaveSearchDataProviderUI);
